import React from 'react';

import { StyleSheet } from 'react-native';

import Currency from 'components/currency';
import { CurrencyLineSkeleton } from 'pages/cart/currency-line-skeleton';
import { t } from 'state/intl/translations';
import { useUIContext } from 'state/ui';
import { getDesignToken, spacing } from 'styles/constants';

import { useCheckoutContext } from '../../hooks/use-checkout-context';

import { GrandTotalLabel, Total, TotalsRow } from './styled';

interface GrandTotalProps {
  isLoading?: boolean;
}

const GrandTotal: React.FC<React.PropsWithChildren<GrandTotalProps>> = ({ isLoading }) => {
  const { totals } = useCheckoutContext();
  // This makes sure that the grand total is always a number and > 0.
  const grandTotal = totals && totals?.grandTotal > 0 ? totals.grandTotal : 0;
  const { formatCurrencyForLocale } = useUIContext();

  if (isLoading) {
    return (
      <TotalsRow style={styles.grandTotalRow}>
        <CurrencyLineSkeleton />
      </TotalsRow>
    );
  }

  return (
    <TotalsRow
      style={styles.grandTotalRow}
      accessible
      accessibilityRole="text"
      focusable
      accessibilityLabel={`${t('total')}: ${formatCurrencyForLocale(grandTotal)}`}
    >
      <>
        <GrandTotalLabel focusable={false}>{t('total')}</GrandTotalLabel>
        <Total focusable={false}>
          <Currency
            focusable={false}
            testID="grand-total"
            amount={grandTotal}
            isBold
            textProps={{
              fontSize: 'md',
              color: getDesignToken('text-default'),
              style: { margin: 0, flexGrow: 0 },
            }}
          />
        </Total>
      </>
    </TotalsRow>
  );
};

export default GrandTotal;

const styles = StyleSheet.create({
  grandTotalRow: {
    marginTop: spacing.$4,
  },
});
